import { useEffect } from 'react';

import { useFirstRender } from 'hooks/useFirstRender';
import { useFormContext, useWatch } from 'react-hook-form';
import type { TextInputProps } from 'shared/react-admin/Inputs';

import { StyledTextInput } from './WatchedTextInput.styled';

export type WatchedTextInputProps = {
  watchField: string;
} & TextInputProps;

export const WatchedTextInput = ({ watchField, ...props }: WatchedTextInputProps): JSX.Element => {
  const { clearErrors, setValue } = useFormContext();
  const watchedValue = useWatch({ name: watchField });
  const { isFirstRender } = useFirstRender();

  useEffect(() => {
    if (!isFirstRender) {
      setValue(props.source, null);
      clearErrors(props.source);
    }
  }, [watchedValue]);

  return <StyledTextInput {...props} />;
};
